import { render, staticRenderFns } from "./AccountType.vue?vue&type=template&id=56cae7b5&scoped=true&"
import script from "./AccountType.vue?vue&type=script&lang=js&"
export * from "./AccountType.vue?vue&type=script&lang=js&"
import style0 from "./AccountType.vue?vue&type=style&index=0&id=56cae7b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cae7b5",
  null
  
)

export default component.exports